import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { scrollToBooking } from "@/lib/clinic";
import { TrustHeader } from "@/components/site/TrustHeader";
import { Hero } from "@/components/site/Hero";
import { Reviews } from "@/components/site/Reviews";
import { Services } from "@/components/site/Services";
import { Doctor } from "@/components/site/Doctor";
import { Location } from "@/components/site/Location";
import { Footer } from "@/components/site/Footer";
import { MobileBookBar } from "@/components/site/MobileBookBar";

export default function Landing() {
  const [config, setConfig] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [preselect, setPreselect] = useState(null);

  useEffect(() => {
    api.get("/public/config").then((r) => setConfig(r.data));
    api.get("/reviews").then((r) => setReviews(r.data));
  }, []);

  const bookReason = (id) => {
    setPreselect({ id, n: Date.now() });
    scrollToBooking();
  };
  const fee = config?.consultation_fee ?? 500;

  return (
    <div className="min-h-screen bg-alabaster text-ink pb-24 md:pb-0" data-testid="landing-page">
      <TrustHeader />
      <Hero config={config} preselect={preselect} />
      <Reviews reviews={reviews} />
      <Services onBook={bookReason} />
      <Doctor />
      <Location config={config} />
      <Footer />
      <MobileBookBar fee={fee} />
    </div>
  );
}
